import { VehicleNameFormatter } from './VehicleNameFormatter';
import { VehicleStatusCalculator } from './VehicleStatusCalculator';

export class VehicleDataEnricher {
  static enrichVehicle(vehicle: any, isAudiMake: boolean): any {
    const trimmedName = VehicleNameFormatter.removeYearFromModelName(vehicle, isAudiMake);
    const orderType = VehicleStatusCalculator.getSaleOrderType(vehicle);
    const orderStatus = VehicleStatusCalculator.getOrderStatus(vehicle);

    return {
      ...vehicle,
      titleText: trimmedName || vehicle.titleText || '',
      salesInfo: {
        ...vehicle.salesInfo,
        saleOrderTypeText: orderType ?? undefined,
        orderStatusText: orderStatus ?? undefined,
      },
    };
  }

  static createPromotionVehicle(offers: any): any {
    return {
      modelName: offers.modelName,
      modelYear: offers.modelYear,
      trimName: offers.trimName,
    };
  }
}
